export default __webpack_public_path__ + "static/Good Sleep Makes Better Athletes-892a44c2dcdc8b8c014ea48ba3663176.jpg";